import * as React from "react";
import { styled } from "styled-components";
import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { createEditableProps } from "@ludens-reklame/rubics-v3-react/util/fns";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import {
  Constrainer,
  VerticalSpacer,
  HorizontalSpacer,
} from "../../internal-components/Layout.js";
import { RichText } from "../../internal-components/RichText.js";

interface Props {
  text?: string;
  image?: Image;
}

export const CoverPhoto: React.FC<Props> = ({ text, image }) => {
  if (!image) return null;

  return (
    <HeroContainer>
      <ImageWrapper
        backgroundImage={transformImageUrl(image, { width: 1920 })}
      />
      <VerticalSpacer
        className="hero-content"
        desktopGutter="xl"
        mobileGutter="l"
      >
        <HorizontalSpacer desktopGutter="xl" mobileGutter="l">
          <Constrainer $width="medium">
            {text && (
              <TextWrapper>
                <RichText
                  dangerouslySetInnerHTML={{ __html: text }}
                  {...createEditableProps("html", "text")}
                />
              </TextWrapper>
            )}
          </Constrainer>
        </HorizontalSpacer>
      </VerticalSpacer>
    </HeroContainer>
  );
};

const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-bottom-left-radius: ${(props) => props.theme.borderRadius};
  border-bottom-right-radius: ${(props) => props.theme.borderRadius};

  @media all and (min-width: ${mobileBreakPointCSS}) {
    height: 800px;
  }

  .hero-content {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

const ImageWrapper = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.1) 10%,
      rgba(0, 0, 0, 1) 100%
    );
    pointer-events: none;

    @media all and (min-width: ${mobileBreakPointCSS}) {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.1) 30%,
        rgba(0, 0, 0, 1) 100%
      );
    }
  }
`;

const TextWrapper = styled.div`
  color: #fff;
  max-width: 600px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: ${(props) => props.theme.spacing.s};
  }
`;
